<template>
  <q-card class="analysis">
    <q-card-section>
      <div class="header">
        <div class="title">
          Read/Publish Analysis
        </div>

        <q-btn color="positive" @click="$emit('analyze')">Analyze</q-btn>
      </div>

      <div v-if="analysisLoaded" class="analysis-content">
        <AnalysisReadPublish class="analysis-table" :rows="readPublishAnalysis" />

        <div class="cards publish-analysis">
          <DisplayCard v-for="card of publishAnalysis" :key="card.id" :title="card.title" :subtitle="card.subtitle" />
        </div>

        <AnalysisChart
          class="subs-spend"
          :title="`Subscription spend per year (${currency})`"
          :chart-data="charts.subscription_spend_per_year.chart"
        />

        <AnalysisChart
          class="publishing-costs"
          :title="`Publishing costs per year (${currency})`"
          colored
          :chart-data="charts.publishing_costs_per_year.chart"
        />

        <AnalysisChart
          class="articles-published"
          title="Articles published per year"
          :chart-data="charts.articles_published_per_year.chart"
        />

        <div class="cards info-boxes">
          <DisplayCard v-for="card of infoBoxes" :key="card.id" :title="card.title" :subtitle="card.subtitle" />
        </div>

        <ArticlesContributions :data="top10Info" />
      </div>

      <div v-else class="no-cards text-subtitle1 text-weight-thin">
        {{ noCardsText }}
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
import priceFormat from '@/mixins/price-format'
import { getPublishAnalysis, getInfoBoxes } from './cardsData'
// Components
import DisplayCard from '../../../../shared/DisplayCard'
import AnalysisChart from './AnalysisChart'
import ArticlesContributions from './ArticlesContributions'
import AnalysisReadPublish from './AnalysisReadPublish'

export default {
  components: {
    DisplayCard,
    AnalysisChart,
    ArticlesContributions,
    AnalysisReadPublish
  },

  mixins: [priceFormat],

  props: {
    noCardsText: String
  },

  data: () => ({
    publishAnalysis: null,
    charts: null,
    infoBoxes: null,
    top10Info: null,
    readPublishAnalysis: null,
    analysisLoaded: false
  }),

  computed: {
    currency() {
      return this.settings.currency
    }
  },

  methods: {
    setData(data) {
      this.readPublishAnalysis = [data.read_publish_analysis]
      this.setPublishAnalysis(data.info_boxes, data.read_publish_analysis)
      this.setInfoBoxes(data.info_boxes)
      this.charts = data.charts
      this.top10Info = data.top_10_info
      this.analysisLoaded = true
    },

    setPublishAnalysis(info, analysis) {
      this.publishAnalysis = getPublishAnalysis(info, analysis)
    },

    setInfoBoxes(data) {
      this.infoBoxes = getInfoBoxes(data, this.pf_convertNumberToPrice, this.settings.currency)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/custom-variables'

.analysis {
  display grid

  .header {
    display flex
    justify-content space-between
    align-items center

    .title {
      font-size 1.125rem
    }
  }

  .read-publish-table {
    padding 15px 5px
  }

  .analysis-content {
    display grid
    gap 20px
    grid-template-columns repeat(3, 1fr)

    .analysis-table, .cards {
      grid-column 1 / -1
    }
  }

  .cards {
    display flex
    flex-wrap wrap
    justify-content center
    padding 0 5px

    .display-card {
      margin 5px 10px
      width 200px
      background-color $tertiary
    }
  }

  .info-boxes {
      grid-column span 2
      grid-template-columns repeat(auto-fit, 200px)
      justify-content center
    }

  .no-cards {
    padding 15px 5px
    text-align center
  }

}

@media only screen and (max-width: 1280px) {
  .analysis-content {
    grid-template-columns repeat(2, 1fr) !important

    .articles-published {
      grid-area 5 / 1
    }
  }
}
</style>
